/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  Component,
  Inject,
  Vue,
} from 'vue-property-decorator';

// WithAppContext accesses properties provided by App.vue.
@Component
export default class WithAppContext extends Vue {
  @Inject({ from: 'context' }) private readonly appContext!: {
    isMobile: boolean;
    hideFixedNavbar: boolean;
  };

  get isMobile() {
    return this.appContext.isMobile;
  }

  get hideFixedNavbar() {
    return this.appContext.hideFixedNavbar;
  }
}
